// Import Template
import Default from './Default'
import color from './Color'
import size from './Size'
import general from './General'

export default {
    Default,
    color,
    size,
    general
}